import { Empty_FlowchartPaper_Interface, FlowchartPaper_Interface } from "./FlowchartPaper_Interface"

export interface PersoneOffDay_Interface {
    id:number,
    dsc:String,
    startDate:String,
    endDate:String,
    amount:number,
    offday:number,
    fullname:String,
    replace_person:String,
    persianDate:String,
    status:number,
    flowchart:FlowchartPaper_Interface
}

export function Empty_PersoneOffDay_Interface():PersoneOffDay_Interface{
    return{
      id:0,
      dsc:'',
      startDate:'',
      endDate:'',
      amount:0,
      offday:0,
      fullname:'',
      replace_person:'',
      persianDate:'',
      status:0,
      flowchart:Empty_FlowchartPaper_Interface()
    }
  }